module.exports = __webpack_public_path__ + "img/home-hero-mobile-img.f74106e1.svg";